export default __webpack_public_path__ + "static/media/CV_MANDIN_01_22_comp.8c4885eb.pdf";